import { Grid } from "@mui/material";
import React from "react";
import { useAuth } from "../../../../../hooks";
import QTDetailsImageWithLabelSection from "../../../../../common/QTDetailsImageWithLabelSection";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";

const UserProfileTopFiledsSection = ({
  userData,
  setUserData,
  handleImagePreviewModalOpen,
  editEnabled,
  uploadImage,
  setUploadImage,
  newPassword,
  setNewPassword,
}) => {
  const { currentUser } = useAuth();

  const image = currentUser?.photoUrl
    ? currentUser?.photoUrl
    : "https://github.com/creativetimofficial/soft-ui-dashboard-tailwind/blob/main/build/assets/img/team-2.jpg?raw=true";

  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*photo section*/}
        <QTDetailsImageWithLabelSection
          label={"Profile Photo"}
          image={image}
          handleImagePreviewModalOpen={handleImagePreviewModalOpen}
          editEnabled={editEnabled}
          uploadImage={uploadImage}
          setDetails={setUserData}
          details={userData}
          setUploadImage={setUploadImage}
        />
        {/*First Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Password"}
          name="New Password"
          id="newPassword"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          disabled={true}
          editEnabled={editEnabled}
          // onChange={(e) =>
          //   setAdminUserDetails({
          //     ...adminUserDetails,
          //     firstName: e.target.value,
          //   })
          // }
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        <QTDetailsTextFieldWithLabelSection
          label={"First Name"}
          value={userData?.firstName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setUserData({
              ...userData,
              firstName: e.target.value,
            })
          }
        />
        {/*Role section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Last Name"}
          value={userData?.lastName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setUserData({
              ...userData,
              lastName: e.target.value,
            })
          }
        />
      </Grid>
    </Grid>
  );
};

export default UserProfileTopFiledsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
};
